import styled from "styled-components";

export const LeftButtonSection = styled.div``;
export const RightSearchSection = styled.div`
  flex: 0 500px;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 20px;
`;

export const TableWrapper = styled.div`
  padding-left: 20px;
  padding-right: 20px;
`;
